var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"4"}},[_c('ImageUpload')],1)],1),_c('PhotoGallery')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }